<div class="flex items-center justify-center w-full h-screen -my-20 bg-pattern">
  <div
    class="w-1/2 p-10 overflow-hidden text-center shadow-xl card"
  >
    <div class="flex flex-col items-center p-6">
      <img class="w-56" src="assets/img/gk/logo.svg" />
    </div>

    <h1 class="m-0 font-medium display-1">Stránka se připravuje</h1>
    <h3 class="mt-3 mb-0 title">Tato stránka není momentálně k dispozici</h3>

  </div>
</div>

